import { useState, useEffect } from "react";
import { DatePicker, Image, Spin, ConfigProvider, message } from "antd";
import dayjs from "dayjs";
import Header from "../../../component/menu/Header";
import { constants } from "../../../constant/constants";
import SideMenu from "../../../component/menu/SideMenu";
import useUserStore from "../../../stores/store";
import { getDownloadableData, getInventoryFinalReport } from "../../../services/inventory/final-report.service";
import { ReportService } from "../../../services/reports-services";
import CustomLoader from "../../../component/menu/CustomLoader";
import { getParsedNumber, isDate1GreaterThanDate2 } from "../../../utils/Common";
import CustomInputNumber from "../../../component/CustomInputNumber";

export default function FinalReport() {
  const { user, restaurantId, showNotification, setNetworkCall } = useUserStore();
  const [filters, setFilters] = useState({
    restaurantId: restaurantId,
    fromDate: new Date().toLocaleDateString("en-CA"),
    toDate: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [record, setRecord] = useState({
    sales: 0,
    inventoryCost: 0,
    operationalCost: 0,
    otherCost: 0,
    wastage: 0,
    carriageInwards: 0,
    totalCost: 0,
    grossProfit: 0,
    totalVat: 0,
    totalServiceCharge: 0,
  });

  const [calcValues, setCalcValues] = useState({ otherCost: 0, totalCost: 0, grossProfit: 0 });

  const calculateTotalCost = (updatedOtherCost) => {
    const { totalCost } = record;

    return Number(totalCost) + Number(updatedOtherCost);
  };

  const handleOtherCostChange = (val) => {
    let newOtherCost = getParsedNumber(val);

    const newTotalCost = calculateTotalCost(newOtherCost);
    const otherTotalCost = newTotalCost + getParsedNumber(record.totalVat) + getParsedNumber(record.totalServiceCharge) + getParsedNumber(record.wastage)
    const newGrossProfit = record.sales - otherTotalCost;

    setCalcValues({
      otherCost: val,
      totalCost: newTotalCost,
      grossProfit: newGrossProfit,
    });
  };

  function onHandleFromDate(date, dateString) {
    if (isDate1GreaterThanDate2(dateString, filters.toDate)) {
      showNotification("From Date cannot be greater than To Date.");
      return;
    }

    setFilters((prev) => ({ ...prev, fromDate: dateString }));
  }

  function onHandleToDate(date, dateString) {
    setFilters((prev) => ({ ...prev, toDate: dateString }));
  }

  function onHandleClearFilter() {
    const filters = {
      restaurantId: restaurantId,
      fromDate: new Date().toLocaleDateString("en-CA"),
      toDate: "",
    };

    setFilters(filters);

    fetchData(filters);
  }

  const fetchData = async (params = null) => {
    setIsLoading(true);
    const result = await getInventoryFinalReport(params || filters, user.token.token);

    setIsLoading(false);

    if (result.success) {
      setRecord(result.record);
      setCalcValues((prev) => ({
        ...prev,
        otherCost: result.record.otherCost,
        totalCost: result.record.totalCost,
        grossProfit: result.record.grossProfit,
      }));
    }

    console.log("------------result----------", result);
  };

  async function handleFilterApply() {
    fetchData();
  }

  function handleDownload() {
    const params = {
      ...filters,
      otherCost: calcValues.otherCost,
    };
    setNetworkCall(true);

    getDownloadableData(params, user.token.token).then((res) => {
      if (res.data) {
        ReportService.downloadPDF(res.data, "Final-report.pdf");
        setNetworkCall(false);
      } else {
        showNotification("Failed to download the report");
        setNetworkCall(false);
        return;
      }
    });
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <section>
      <CustomLoader />
      <div className="flex flex-col">
        <Header title={""} menu={""} currentMenuKey={"T_7_S_7_L_6"} />
        <div className="flex flex-row bg-prewhite px-[12%]">
          <SideMenu title={`Final Report`} menu={""} />
        </div>
        <div className=" my-[80px] ml-[80px] px-[50px]">
          <h1 className="pt-[50px] pb-[20px] font-bold text-black text-[24px] leading-[24px] cursor-default">
            {constants.MENU.INVENTORY[6]}
          </h1>

          {/* filter section */}
          <ConfigProvider
            theme={{
              components: {
                DatePicker: {
                  zIndexPopup: 1,
                },
              },
            }}
          >
            <div className="flex items-center justify-between mb-[43px]">
              <div className="flex items-center space-x-[15px] items-center w-full mt-[20px] mb-[31px]">
                <div className="h-[48px] w-[18%]">
                  <DatePicker
                    className={"h-full w-full"}
                    showTime={false}
                    onChange={onHandleFromDate}
                    placeholder="From Date"
                    value={filters.fromDate ? dayjs(filters.fromDate) : null}
                    disabledDate={(current) => current && current > dayjs().endOf("day")}
                  />
                </div>
                <div className="h-[48px] w-[18%]">
                  <DatePicker
                    className={"h-full w-full"}
                    showTime={false}
                    onChange={onHandleToDate}
                    placeholder="To Date"
                    value={filters.toDate ? dayjs(filters.toDate) : null}
                    disabledDate={(current) => {
                      if (!filters.fromDate) {
                        return current && current > dayjs().endOf("day");
                      }
                      return (
                        (current && current < dayjs(filters.fromDate).startOf("day")) || current > dayjs().endOf("day")
                      );
                    }}
                  />
                </div>
                <div className="flex items-center space-x-[20px] h-[48px] w-[200px]">
                  <button
                    className="w-full h-full bg-black text-[14px] font-bold leading-[16px] text-white rounded-[5px] w-[50%]"
                    onClick={onHandleClearFilter}
                  >
                    Clear
                  </button>
                  <button
                    className="w-full h-full bg-[#FCBD10] text-[14px] font-bold leading-[16px] text-black rounded-[5px] w-[50%]"
                    onClick={handleFilterApply}
                  >
                    Apply
                  </button>
                </div>
              </div>

              <div>
                <div className="flex space-x-[10px]">
                  <button onClick={handleDownload}>
                    <Image src="/images/icons/download.svg" preview={false} alt="download-final-inventory-report" />
                  </button>
                </div>
              </div>
            </div>
          </ConfigProvider>

          {/* final report table */}
          {isLoading ? (
            <div className="h-[50vh] flex items-center justify-center">
              <Spin size="large" />
            </div>
          ) : (
            <div className="w-full bg-[#F7FFE8] border border-px border-[#C7C7C7] flex items-center justify-center">
              <table className="w-[calc(100%-100px)]">
                <thead className="text-base font-p_semibold leading-[13px] text-[#019393] h-[80px]">
                  <tr className="border-b border-b-px border-b-[#C7C7C7]">
                    <th className="text-left pl-[20px] text-left">Details</th>
                    <th className="bg-[#FFF6E8] text-center">Amount (TK)</th>
                    <th className="text-center bg-[#F7FFE8]">Total Amount (TK)</th>
                  </tr>
                </thead>
                <tbody className="text-base font-p_medium leading-[13px] text-black">
                  <tr className="h-[50px] border-b border-b-px border-b-[#C7C7C7]">
                    <td className="pl-[20px] text-left text-black">Sales</td>
                    <td className="bg-[#FFF6E8] text-center"></td>
                    <td className="text-center bg-[#F7FFE8]">{record.sales.toFixed(2)}</td>
                  </tr>
                  <tr className="h-[50px] border-b border-b-px border-b-[#C7C7C7]">
                    <td className="pl-[20px] text-left text-black">
                      COGS <span className="text-sm">(Inventory used)</span>
                    </td>
                    <td className="bg-[#FFF6E8] text-center">{record.inventoryCost.toFixed(2)}</td>
                    <td className="text-center bg-[#F7FFE8]"></td>
                  </tr>
                  <tr className="h-[50px] border-b border-b-px border-b-[#C7C7C7]">
                    <td className="pl-[20px] text-left text-black">Operational Cost</td>
                    <td className="bg-[#FFF6E8] text-center">{record.operationalCost.toFixed(2)}</td>
                    <td className="text-center bg-[#F7FFE8]"></td>
                  </tr>
                  <tr className="h-[50px] border-b border-b-px border-b-[#C7C7C7]">
                    <td className="pl-[20px] text-left text-black">Other Cost</td>
                    <td className="bg-[#FFF6E8] text-center">
                      {/* <input
                        min={0}
                        type="number"
                        value={calcValues.otherCost}
                        onChange={handleOtherCostChange}
                        className="border rounded px-2 py-1 text-center w-[100px]"
                      /> */}
                      <div className="flex items-center justify-center">
                        <div className="w-[100px]">
                          <CustomInputNumber
                            value={calcValues.otherCost}
                            setValue={handleOtherCostChange}
                            isDecimalAllowed={true}
                            min={0}
                            inputClasses="w-[100px]"
                          />
                        </div>
                      </div>
                    </td>
                    <td className="text-center bg-[#F7FFE8]"></td>
                  </tr>
                  <tr className="h-[50px] border-b border-b-px border-b-[#C7C7C7]">
                    <td className="pl-[20px] text-left text-black">Carriage Inwards</td>
                    <td className="bg-[#FFF6E8] text-center">{record.carriageInwards.toFixed(2)}</td>
                    <td className="text-center bg-[#F7FFE8]"></td>
                  </tr>
                  <tr className="h-[50px] border-b border-b-px border-b-[#C7C7C7]">
                    <td className="pl-[20px] text-left text-black">Total Cost</td>
                    <td className="bg-[#FFF6E8] text-center"></td>
                    <td className="text-center bg-[#F7FFE8]">
                      {/* {getParsedNumber(calcValues.totalCost) > 0 && <span>- </span>} */}
                      {calcValues.totalCost.toFixed(2)}
                    </td>
                  </tr>
                  <tr className="h-[50px] border-b border-b-px border-b-[#C7C7C7]">
                    <td className="pl-[20px] text-left text-black">Wastage</td>
                    <td className="bg-[#FFF6E8] text-center"></td>
                    <td className="text-center bg-[#F7FFE8]">
                      {record.wastage.toFixed(2)}</td>
                  </tr>
                  <tr className="h-[50px] border-b border-b-px border-b-[#C7C7C7]">
                    <td className="pl-[20px] text-left text-black">Service Charge</td>
                    <td className="bg-[#FFF6E8] text-center"></td>
                    <td className="text-center bg-[#F7FFE8]"> 
                      {record.totalServiceCharge.toFixed(2)}
                    </td>
                  </tr>
                  <tr className="h-[50px] border-b border-b-px border-b-[#C7C7C7]">
                    <td className="pl-[20px] text-left text-black">VAT</td>
                    <td className="bg-[#FFF6E8] text-center"></td>
                    <td className="text-center bg-[#F7FFE8]"> 
                      {record.totalVat.toFixed(2)}
                    </td>
                  </tr>
                  <tr className="h-[70px] border-b border-b-px border-b-[#C7C7C7]">
                    <td className="pl-[20px] text-left text-[#025983] text-base font-p_bold">Gross Profit</td>
                    <td className="bg-[#FFF6E8] text-center"></td>
                    <td className="text-center bg-[#F7FFE8] text-[#025983] text-base font-p_bold">
                      {calcValues.grossProfit.toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
